import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Cotista } from "src/app/model/cotista.model";
import { ResultadoPaginado } from "src/app/model/resultado";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";

export class FiltroCotistas {
  texto?: string;
  pagina?: number = 1;
  limite?: number = 10;
}

@Injectable({
  providedIn: 'root'
})
export class CotistaService extends FgiBackEndService<any>{

  getNewEntity() {
      return null;
  }

  protected getResourceURL(): string {
      return 'front/cotistas';
  }

  getCotistas(texto?: string, tipoOrdenacao?: string) {
    const options = blockUi();
    let params = new HttpParams();
    if (texto) {
      params = params.append('texto', texto);
    }
    if (tipoOrdenacao) {
      params = params.append('tipoOrdenacao', tipoOrdenacao);
    }
    return this.http.get(this.BASE_URL, { params, ...params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<Cotista[]>;
  }


  getCotistasComPaginacao(filtro?: FiltroCotistas) {
    let params = new HttpParams();
    if (filtro && filtro.texto) {
      params = params.append('texto', filtro.texto);
    }
    if (filtro && filtro.pagina) {
      params = params.append('pagina', filtro.pagina);
    }
    if (filtro && filtro.limite) {
      params = params.append('limite', filtro.limite);
    }
    return this.http.get(`${this.BASE_URL}/paginado`, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<ResultadoPaginado<Cotista>>;
  }

}
